import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentRequestOnlineAttemptModel } from '../entity/paymentRequestOnlineAttempt.model';
import {AbstractActionService} from "../../../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {Payload} from "../../../../../../core/service/payload/payload";
import {PaymentRequestOnlineAttemptConverter} from "../entity/converter/paymentRequestOnlineAttempt.converter";

@Injectable()
export class PaymentRequestOnlineAttemptAddByCardActionService extends AbstractActionService<PaymentRequestOnlineAttemptAddByCardPayload, PaymentRequestOnlineAttemptModel> {
    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient,
                private converter: PaymentRequestOnlineAttemptConverter) {
        super('PaymentRequestOnlineAttempt', 'add-by-card', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): PaymentRequestOnlineAttemptModel {
        return this.converter.convert(response);
    }
}

export class PaymentRequestOnlineAttemptAddByCardPayload implements Payload {
    paymentCardReaderId: number;
    amount: number;
    targetAccountId: number;
    paymentRequestId: number;
    description?: string;
}
